import i18n from 'i18next'
import { initReactI18next } from 'react-i18next'
import LanguageDetector from 'i18next-browser-languagedetector'
import HttpBackend from 'i18next-http-backend'

// Bundled English translations — loaded synchronously so the app never
// suspends waiting for an async locale fetch on cold start (including
// when launched offline from the PWA icon).  Other languages still load
// via HttpBackend at runtime, but 'en' is always instantly available.
import enCommon from '../../public/locales/en/common.json'

i18n
  .use(HttpBackend)
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    fallbackLng: 'en',
    partialBundledLanguages: true,
    defaultNS: 'common',
    ns: ['common'],
    // Seed the 'en' namespace synchronously so the first render never
    // suspends even before the HttpBackend has responded.
    resources: {
      en: { common: enCommon },
    },
    backend: {
      loadPath: '/locales/{{lng}}/{{ns}}.json',
    },
    detection: {
      order: ['localStorage', 'navigator'],
      caches: ['localStorage'],
    },
    interpolation: {
      escapeValue: false,
    },
    react: {
      useSuspense: true,
    },
  })

export default i18n
